/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IMfrmProductDetailsViewProps } from './mfrm-product-details';
import AccordionItem from 'mfcl/AccordionItem';

//todo import this
export interface IPanelContent {
    header: string;
    content: React.ReactElement;
    id: string;
}

export default (props: IMfrmProductDetailsViewProps) => {
    const { panelContent } = props;
    return (
        <div className='mfrm-product-details'>
            <div className='mfrm-accordion'>
                {panelContent &&
                    panelContent.length &&
                    panelContent
                        .filter((panel: IPanelContent) => panel.header !== 'Description')
                        .map((panel: IPanelContent, index: number) => {
                            return (
                                <AccordionItem
                                    initialOpen={true}
                                    className='mfrm-accordion__item'
                                    key={index}
                                    title={panel.header}
                                    id={panel.id}
                                    content={panel.content}
                                />
                            );
                        })}
            </div>
        </div>
    );
};
